import React from 'react';
import {ATTENDANCE, CONSTANT, HRMS_STATUS, PAGINATION} from "../../common/constant";
import moment from "moment";
import {getCurrentFinancialYear, getCurrentMonth, getCurrentYear, getPreviousMonth} from "../../common/functions/common";
import {getLocal, setLocal} from "ubs-framework/v2/common/function";
import {sendData} from "../actions";
import {endOfYear, startOfYear} from "date-fns";

export const startDate = new Date(moment().subtract(6, 'days').set({'hour': 0, 'minute': 0, 'second': 0}));
export const endDate = new Date(moment().set({'hour': 0, 'minute': 0, 'second': 0}));

export const startDateMonth = new Date(moment().startOf('month'));
export const endDateMonth = new Date(moment().endOf('month'));

export const monthStart = new Date(moment().startOf('month')).getTime();
export const monthEnd = new Date(moment().endOf('month')).getTime();

export const yearStart = new Date(moment().startOf('year')).getTime();
export const yearEnd = new Date(moment().endOf('year')).getTime();

export const weekStart = new Date(moment().startOf('week').toDate()).getTime();
export const weekEnd = new Date(moment().endOf('week').toDate()).getTime();

export const nextWeekStart = new Date(moment().add(1, 'week').startOf('week').toDate()).getTime();
export const nextWeekEnd = new Date(moment().add(1, 'week').endOf('week').toDate()).getTime();

export const nextDayStart = new Date(moment().add(1, 'days').startOf('day').toDate()).getTime();
export const nextDayEnd = new Date(moment().add(1, 'days').endOf('day').toDate()).getTime();

export const weekStartWithMon = moment().subtract((moment().day() + 6) % 7, 'days').startOf('day').toDate().getTime();
export const weekEndWithSun = moment(weekStartWithMon).add(6, 'days').endOf('day').toDate().getTime();

export const lastSelectedMonth = (month) => {
    return new Date(moment().subtract(month || 1, 'months').startOf('month')).getTime();
}
export const nextSelectedMonth = (month) => {
    return new Date(moment().add(month || 1, 'months').endOf('month')).getTime();
}
export const previousMonth = new Date(moment().subtract(1, 'months').startOf('month')).getTime();

export const nextYear = (start) => {
    return new Date(moment(start).add({'year': 1}).subtract(1, 'days')).getTime()
};

export const previous7DayStart = new Date(moment().subtract(6, 'days').startOf('day')).getTime();
export const todayEnd = new Date(moment().endOf('day')).getTime();

export const secondMonthStart = new Date(new Date(moment().subtract(1, 'months').startOf('month'))).getTime();
export const secondMonthEnd = new Date(new Date(moment().subtract(2, 'months').endOf('month'))).getTime();

export const thirdMonthStart = new Date(new Date(moment().startOf('month')).setMonth(new Date().getMonth() + 2)).getTime()
export const thirdMonthEnd = new Date(new Date(moment().endOf('month')).setMonth(new Date().getMonth() + 2)).getTime()

export const previewthirdMonthStart = new Date(new Date(moment().startOf('month')).setMonth(new Date().getMonth() - 2)).getTime()

export const todayStart = new Date(moment().startOf('day')).getTime();
export const next30DayStart = new Date(moment().add(30, 'days').startOf('day')).getTime();

const initialState = {
    socketId: '',
    _id: '',

    jobInformation: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT},
    agreement: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT},
    compensation: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT},
    myExit: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT},
    probation: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT},
    bankInformation: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT},
    myProfileUpdateRequest: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        status: {label: 'Pending', value: 1},
        assignTemplate: null
    },

    employeeDirectory: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: 'active',
        group: CONSTANT.EMPLOYEE_GROUP[0],
        search: '',
        filter: {},
    },
    esslDeviceFilter: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
    },
    employeeList: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: 'active',
        search: '',
        action: '',
        filter: {},
        sort: {firstName: 1}
    },
    employeeTree: {
        userId: '',
        department: '',
    },
    employeeProbation: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: 'active',
        view: 'list',
        search: '',
        filter: {
            probationStartDate:{
                start: null,
                end: null,
            },
            probationEndDate :{
                start: yearStart,
                end: yearEnd,
            },
            startDate: yearStart,
            endDate: yearEnd,
        },
        sort: {end: 1},
        probationActive: true,
        isType: '',
    },
    dashBoardReportView: 'grid',
    mheDashBoardView: 'grid',
    employeeExit: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: 'active',
        search: '',
        // filter: {
        //     start: previousMonth,
        //     end: nextYear(previousMonth),
        //     isRevoke: false
        // },
        filter: {
            start: yearStart,
            end: yearEnd,
            isRevoke: false
        },
        sort: {end: 1}
    },
    employeeAgreement: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: 'active',
        search: '',
        filter: {
            agreementStartDate: {
                start: yearStart,
                end: yearEnd,
            },
            agreementEndDate :{
                start: yearStart,
                end: yearEnd,
            },
            startDate: yearStart,
            endDate: yearEnd,
        },
        sort: {end: 1},
        view: 'list'
    },
    employeeCompensation: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: 'active',
        search: '',
        filter: {
            compansationStartDate:{
                start: monthStart,
                end: monthEnd,
            },
            compansationEndDate :{
                start: monthStart,
                end: monthEnd,
            },
            startDate: yearStart,
            endDate: yearEnd,
        },
        sort: {end: 1},
        view: 'list'
    },
    employeeCompensationGrid: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: 'active',
        search: '',
        startDate: monthStart,
        endDate: new Date(moment(monthStart).add({'year': 2}).subtract(1, 'months').endOf('month'))?.getTime(),
        filter: {
            from: '',
            to: ''
        },
        sort: 'firstName'
    },
    profileUpdateRequest: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        status: {label: 'Pending', value: 1},
        assignTemplate: null, // null and True : dont use false Boolean value value
    },
    employeeExitRequest: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        status: {label: 'Pending', value: 1},
        resignationStatus : {label: 'Resignation Request',value: 1},
        type: {value: 'active', label: 'Active'},
        filter: {
            verificationStatus: HRMS_STATUS?.TIME_SHEET_REQUEST_STATUS?.PENDING
        }
    },
    employeeRevokeRequest: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        status: {label: 'Pending', value: 1},
        revokeStatus : {label: 'Revoke Request',value: 1},
        type: 'all',
        filter: {
            verificationStatus: HRMS_STATUS?.TIME_SHEET_REQUEST_STATUS?.PENDING
        }
    },
    fullAndFinalSettlement: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    fullAndFinalSettlementForStep1: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    fullAndFinalSettlementInEmpList: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        jobTitle: '',
        filter:{}
    },
    leaveAssigned: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT},
    leaveAccrualDetail: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT},
    myAttendance: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        view: ATTENDANCE.ATTENDANCE_SINGLE_USER,
        filter: {
            startDate: previous7DayStart,
            endDate: todayEnd,
        }
    },
    employeeAttendance: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        view: ATTENDANCE.ATTENDANCE_USER,
        type: 'all',
        isDownload: false,
        filter: {
            date: todayEnd,
            dayFilter: "",
            typeFilter: "",
            shiftNotStarted: "" // when Active Must Send Boolean Value To backend
        },
    },
    attendanceUserVerification: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        view: ATTENDANCE.ATTENDANCE_VERIFICATION_SINGLE_USER,
        filter: {
            startDate: previous7DayStart,
            endDate: todayEnd,
            verificationStatus: HRMS_STATUS?.TIME_SHEET_REQUEST_STATUS?.PENDING
        }
    },
    attendanceVerification: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        view: ATTENDANCE.ATTENDANCE_VERIFICATION_USER,
        type: 'all',
        filter: {
            date: todayEnd,
            verificationStatus: HRMS_STATUS?.TIME_SHEET_REQUEST_STATUS?.PENDING,
            dayFilter: "",
            typeFilter: "",
            shiftNotStarted: "" // Boolean Value Send To Backend
        },
    },
    myStatusReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        view: ATTENDANCE.ATTENDANCE_MY_WORK_LOG,
        filter: {
            start: previous7DayStart,
            end: todayEnd,
        }
    },
    employeeStatusReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        view: ATTENDANCE.ATTENDANCE_WORK_LOG,
        type: 'all',
        filter: {
            timeStatus: 0,
            date: todayEnd,
        }
    },
    attendanceType: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: 'all',
    },
    attendanceRegularization: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: 'all',
        filter: {
            sortByConversation: false,
            start: previous7DayStart,
            end: todayEnd,
            status: 1
        },
    },
    inboxCommenAttendance :{
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: 'all',
        filter: {}
    },
    workingDay: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        filter: {
            start: yearStart,
            end: yearEnd,
        },
    },
    nonWorkingDay: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        filter: {
            start: yearStart,
            end: yearEnd,
            type: undefined,
        },
    },

    geoFencing: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT},
    biometrics: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT},
    biometricsUser: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT},
    shiftScheduler: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT},

    onBoardingFields: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT, search: ''},


    myRequest: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: startDate,
        endDate: endDate,
        selectedEmployee: '',
        status: {label: 'Pending', value: 1},
    },
    shiftChangeRequest: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: startDate,
        endDate: endDate,
        selectedEmployee: '',
        status: {label: 'Pending', value: 1},
    },
    empShiftChangeRequest: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: startDate,
        endDate: endDate,
        selectedEmployee: '',
        status: {label: 'Pending', value: 1},
    },
    odRequest: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: startDate,
        endDate: endDate,
        selectedEmployee: '',
        status: {label: 'Pending', value: 1},
        search:'',
        typeOfRemoteWork:'',
        sort: {from: -1},

    },
    myOdRequest: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: startDate,
        endDate: endDate,
        selectedEmployee: '',
        status: {label: 'Pending', value: 1},
        typeOfRemoteWork:''
    },
    masterLocation: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: {value: 'active', label: 'Active'}
    },
    employeeLoginIP: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        filter: {},
        search: '',
        jobTitle: '',
        department: '',
        location: '',
    },
    masterCategory: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    locationBillingType: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    industryList: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterActivity: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterDepartment: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterSubDepartment: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterClockInMethod: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterAttendanceType: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterAttendanceReason: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterIDProof: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterDegree: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterRelationship: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterEmployeeStatus: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterEmployeeExit: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterShift: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterShiftRequest: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterOnduty: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterWeekend: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterPenalisation: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    shiftAssigned: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterBreak: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    workDiaryAssigned: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterAccessLevel: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    accessLevelUnAssigned: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    employeeExitFilter: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        department: ''
    },
    onboardingTemplate: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: ''
    },
    onboardingCandidateList: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        isDeleted: false, // for  deleted Employee list
        filter: {
            onboardStatus: 0,
            joiningDate: {
                startDate: monthStart,
                endDate: monthEnd,
            }
        }
    },
    onboardingUserList: {
        search: '',
        isDeleted: false,
        filter: {
            department: [],
            location: [],
            jobTitle: [],
            joiningDate: {
                startDate: monthStart,
                endDate: monthEnd,
            },
        }
    },
    onboardingUserTaskList: {
        search: '',
        dueDate: null,
        assignTo: null
    },
    onboardingFields: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: ''
    },
    onboardingTasks: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: ''
    },
    policyDocuments: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    referralPolicy: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: ''
    },
    praiseSettings: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    feedbackTypeSetting: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    coreValues: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    timelinePraise: {
        isArchived: false,
        limit: 10,
        currentPage: PAGINATION.CURRENT_PAGE,
    },
    timelineFeedback: {
        isArchived: false,
        limit: 10,
        currentPage: PAGINATION.CURRENT_PAGE,
        filterType: 1
    },
    timelineInternalNotes: {
        limit: 10,
        currentPage: PAGINATION.CURRENT_PAGE,
    },
    timelineFeedbackRequests: {
        isArchived: false,
        limit: 10,
        currentPage: PAGINATION.CURRENT_PAGE,
        filterType: 2
    },
    activityTimeline: {
        limit: PAGINATION.LIMIT,
        currentPage: PAGINATION.CURRENT_PAGE,
    },
    absentPresent: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        date: new Date(),
        filter: '',
        search: ''
    },
    absentPresentView: getLocal('u_apv') ? getLocal('u_apv') : 'grid',
    holidayAllFilter: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        status: 1,
        type: 1,
        startDate: startDate,
        endDate: endDate,
        year: new Date().getFullYear()
    },
    holidayRequest: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: startDate,
        endDate: endDate,
        selectedEmployee: '',
        status: 1,
        search: ''
    },
    holidayMasterAllFilter: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        year: {
            value: new Date().getFullYear().toString()
        },
        type: {value: 'active', label: 'Active'}
    },
    myEarlyOutFilters: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: 'eo',
        filter: {
            startDate: monthStart,
            endDate: todayEnd
        }
    },
    lateInFilters: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'all', label: 'All Employees'},
        filter: {
            startDate: monthStart,
            endDate: todayEnd
        }
    },
    myLateInFilters: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: 'all',
        filter: {
            startDate: monthStart,
            endDate: todayEnd
        }
    },
    earlyOutFilters: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        employee: '',
        type: {value: 'all', label: 'All Employees'},
        settled: false,
        filter: {
            startDate: monthStart,
            endDate: todayEnd
        }
    },
    OTPolicy: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        startDate: startDate,
        endDate: endDate,
    },
    overTimeAdd: {
        selectedEmployee: null,
        date: '',
    },
    myOverTime: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: startDate,
        endDate: endDate,
        status: {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
    },
    overTime: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: startDate,
        endDate: endDate,
        search: '',
        status: {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
    },
    payCode: {
        search: '',
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT
    },
    shiftCalendar: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: 'active',
        filter: {
            start: monthStart,
            end: monthEnd,
        }
    },
    compOffPolicyFilters: {
        search: '',
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        action: 'name'
    },
    myCompOffFilters: {
        status: {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: startDate,
        endDate: endDate,
    },
    compOffFilters: {
        status: {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: startDate,
        endDate: endDate,
        searchByUser: ''
    },
    compOffAdd: {
        employee: null,
        date: '',
    },
    presentDefault: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
    },
    newJoineesReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'Active Employees'},
        jobTitle: '',
        department: '',
        month: getPreviousMonth(),
        year: getCurrentYear()
    },
    earlyOutSummaryReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'all', label: 'All Employees'},
        jobTitle: '',
        department: '',
        date: new Date(),
    },
    earlyOutUserSummaryReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        // type:{ value: 'all', label: 'All Employees' },
        jobTitle: '',
        department: '',
        selectedEmployee: '',
        startDate: startDate,
        endDate: endDate,
    },
    lateInSummaryReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'all', label: 'All Employees'},
        jobTitle: '',
        department: '',
        filter: {
            startDate: monthStart,
            endDate: todayEnd,
        }
    },
    inboxAuditLog: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        action: '',
        actionBy: '',
        createdBy: '',
    },
    attendanceALLSummaryReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'all', label: 'All Employees'},
        jobTitle: '',
        department: '',
        date: new Date(),
    },
    wagesState: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: ''
    },
    wagesStateDetail: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: ''
    },
    wagesEmployment: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: ''
    },
    wagesWorker: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: ''
    },
    wagesZone: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: ''
    },
    empStatusReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'Active Employees'},
        jobTitle: '',
        department: '',
        month: getPreviousMonth(),
        year: getCurrentYear()
    },
    empTaxRegimeReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'Active Employees'},
        jobTitle: '',
        department: '',
        taxRegime: {value: '', label: 'All'},
        year: getCurrentFinancialYear(),
    },
    empTaxRegimeFinancialFilter: {
        financialYear: getCurrentFinancialYear(),
    },
    empInsuranceReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: 'active',
        jobTitle: '',
        department: '',
    },
    yearlySummaryReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        year: getCurrentYear(),
        user: null
    },
    empCovidReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: 'active',
        jobTitle: '',
        department: '',
        year: getCurrentYear(),
        companyId: ''
    },
    empInsuranceTypeFilter: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    empPersonalReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'Active Employees'},
        jobTitle: '',
        department: '',
        month: getPreviousMonth(),
        year: getCurrentYear()
    },
    profileCompletion: {
        filter: {},
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
    },
    empPersonalDocumentReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'Active Employees'},
        jobTitle: '',
        department: '',
        month: getPreviousMonth(),
        year: getCurrentYear()
    },
    empExitReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'Active Employees'},
        date: {startDate: monthStart, endDate: monthEnd},
        lastDate: {startDate: monthStart, endDate: monthEnd},
        resignations:{startDate:monthStart, endDate: monthEnd},
    },
    empEmergencyReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'Active Employees'},
        jobTitle: '',
        department: '',
        month: getPreviousMonth(),
        year: getCurrentYear()
    },
    statutoryReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        statutoryType: {label: 'All', value: 1}
    },

    empTransferReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'all', label: 'All Employees'},
        jobTitle: '',
        department: '',
        month: getPreviousMonth(),
        year: getCurrentYear()
    },
    deptDetailsReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'Active Employees'},
        jobTitle: '',
        department: '',
        month: getPreviousMonth(),
        year: getCurrentYear()
    },
    orgReport: {
        year: getCurrentYear()
    },
    downloadRequestReport: {
        filter: {},
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT100,
    },
    uploadReport: {
        // filter: {},
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    attendanceSummaryReport: {
        filter: {
            start: monthStart,
            end: todayEnd
        },
        type: 'active',
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        department: "",
        location: "",
        jobTitle: "",
        companyId: "",
    },
    companyHoursReport: {
        filter: {},
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        start: monthStart,
        end: monthEnd,
        type: {value: 'active', label: 'Active Employees'},
    },
    ctcReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        start: monthStart,
        end: monthEnd,
        type: {value: 'active', label: 'Active Employees'},
    },
    deptReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    masterJobTitle: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    jobTitleReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    jobTitleDetailsReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'Active Employees'},
        jobTitle: '',
        department: '',
        month: getPreviousMonth(),
        year: getCurrentYear()
    },
    locationReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    locationDetailsReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'Active Employees'},
        jobTitle: '',
        department: '',
        month: getPreviousMonth(),
        year: getCurrentYear()
    },
    subLocationReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'All'}
    },
    clusterReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: "all",
    },
    experienceReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    experienceDetailsReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'all', label: 'All Employees'},
        jobTitle: '',
        department: '',
        month: getPreviousMonth(),
        year: getCurrentYear()
    },
    genderReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    genderDetailsReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'Active Employees'},
        jobTitle: '',
        department: '',
        month: getPreviousMonth(),
        year: getCurrentYear()
    },
    dailyAttendanceReport: {
        date: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    attendanceReportDashBoard: {
        month: getCurrentMonth(),
        year: getCurrentYear()
    },
    mheDashboard: {
        filterType: 2,
        startDate: weekStartWithMon,
        endDate: weekEndWithSun,
    },
    budgetReport: {
        filter: {
            status: 2
        },
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
    },
    dailyAttendanceLocationReport: {
        date: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    customReportWithSabbaticalLeave: {
        date: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    dailyAttendanceByDepartmentLocationReport: {
        start: previous7DayStart,
        end: todayEnd,
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    employeeStatisticsPayrollReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'all', label: 'All Employees'},
        jobTitle: '',
        department: '',
        month: new Date().getMonth(),
        year: getCurrentYear(),
        groupBy: {value: 'companyId', label: 'Company-wise'}, // {value: 'location', label: 'Location Wise'},
    },
    penalisationListPayroll: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        status: {label: 'Pending', value: 1},
        search: '',
    },
    employeeStatisticsLoginReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'Active Employees'},
        jobTitle: '',
        department: '',
        startDate: monthStart,
        endDate: todayEnd
    },
    minimumWagesReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'Active Employees'},
    },
    minimumWagesReportDetail: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        type: {value: 'active', label: 'Active Employees'},
        wagesType: {value: 1, label: 'All'},
    },
    biometricPunchesReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        date: new Date(),
    },
    biometricPunchesInfo: {
        filter: {},
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        start: monthStart,
        end: monthEnd,
    },
    clockINMethodReport: {
        filter: {
            clockInType: 1,
            type:1

        },
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        start: monthStart,
        end: monthEnd,
    },
    liveTrackingActivityReport:{
        filter: {
            start: monthStart,
            end: monthEnd,
        },
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    employeeBreakReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        filter: {
            startDate: monthStart,
            endDate: monthEnd,
        },
    },
    employeeHistory: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    activityLogHistory: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: 14,
        filter: {
            startDate: monthStart,
            endDate: todayEnd,
            status: 1
        },
    },
    biometricDevice: {
        filter: {},
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        start: monthStart,
        end: monthEnd,
    },
    biometricLocation: {
        filter: {},
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        start: monthStart,
        end: monthEnd,
    },
    performanceReport: {
        start: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        end: new Date(),
    },
    overtimeReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: 40,
        month: new Date().getMonth(),
        year: getCurrentYear(),
        status: {label: 'Approved', status: 'approved', color: '#60B158', value: 2},
        type: 'all',
    },
    extraHours: {
        filter: {},
        date: +new Date()?.getTime(),
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    internshipProbationStatus: {
        filter: {},
        date: todayEnd,
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    consecutiveExtraTime: {
        search: '',
        filter: {
            start: monthStart,
            end: monthEnd
        },
        department: '',
        location: '',
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    zoneInfo: {
        filter: {},
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        start: monthStart,
        end: monthEnd,
    },
    biometricAssignReport: {
        filter: {},
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: {value: 'active', label: 'Active Employees'},
        // view: {label: 'Mismatched', value: 4},
    },
    biometricRecords: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        filter: {
            start: monthStart,
            end: monthEnd,
        }
    },
    biometricFailRecord: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },

    monthlyAttendance: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: {value: 'active', label: 'Active Employees'},
        detailsView: false,
        search: '',
        filter: {
            start: monthStart,
            end: monthEnd,
            shift: "",
            subDepartment: "",
        }
    },

    // import bulk

    weekendpolicy: {
        type: {value: 'WEEKEND'},
    },
    ShiftRequestPolicy: {
        type: {value: 'SHIFT_CHANGE_REQUEST'},
    },
    PenalisationPolicy : {
        type: {value: 'PENALISATION'},
    },
    OnDutyPolicy : {
        type: {value: 'ON_DUTY'},
    },
    OverTimePolicy: {
        type: {value: 'OVERTIME'},
    },
    CompOffPolicy: {
        type: {value: 'COMPOFF'},
    },
    LeavePolicy: {
        type: {value: 'LEAVE'},
    },
    ImportPolicyDocument : {
        type: {value: 'POLICY_DOCUMENT'},
    },
    ImportReferrelPolicy: {
        type: {value: 'REFERRAL'},
    },

    queryBuilder: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        year: getCurrentFinancialYear(),
        payrollType: 1,
        search: '',
        viewType: ''
    },
    queryBuilderFilter: {},

    attendanceVerificationReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        department: '',
        type: {value: 'all', label: 'Active Employees'},
        location: '',
        jobTitle: '',
        search: '',
        filter: {
            start: previous7DayStart,
            end: todayEnd,
            verificationStatus: HRMS_STATUS?.TIME_SHEET_REQUEST_STATUS?.PENDING
        }
    },

    documentLetter: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT},
    employeesLetter: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT},
    insuranceInfo: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT},
    signatureList: {currentPage: PAGINATION.CURRENT_PAGE, limit: PAGINATION.LIMIT, search: ''},
    // Leave report - Daily Leave Report
    dailyLeaveReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        designation: '',
        department: '',
        location: '',
        search: '',
        sort: {firstName: 1},
        type: {value: 'active', label: 'Active Employees'},
        date: new Date(),
    },
    leaveBookedBalancedReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        designation: '',
        department: '',
        location: '',
        search: '',
        sort: {firstName: 1},
        type: {value: 'active', label: 'Active Employees'},
        date: new Date(),
    },
    leaveTypeWiseReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        designation: '',
        department: '',
        location: '',
        search: '',
        leaveType: {},
        sort: {firstName: 1},
        type: {value: 'active', label: 'Active Employees'},
        startDate: startDate,
        endDate: endDate
    },
    attendanceCount: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        designation: '',
        department: '',
        location: '',
        search: '',
        leaveType: {},
        sort: {firstName: 1},
        type: {value: 'active', label: 'Active Employees'},
        startDate: monthStart,
        endDate: todayEnd
    },
    leaveEnashmentReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        designation: '',
        department: '',
        location: '',
        search: '',
        sort: {firstName: 1},
        type: {value: 'active', label: 'Active Employees'},
        startDate: startDateMonth,
        endDate: endDateMonth
    },
    compOffReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        month: new Date().getMonth(),
        year: getCurrentYear(),
        status: {label: 'Approved', status: 'approved', color: '#60B158', value: 2},
        type: 'all'
    },
    otherDocument: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
    },
    helpDesk: {
        category: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
        },
        status: {
            search: '',
        },
        cannedResponses: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
        },
        activity: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
        },
        tagList: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
        },
    },
    orgStructure: {
        zone: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
            type: "all",
        },
        bussinessUnit: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
            type: 1,
        },
        costCenter: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
            type: 2,
        },
        bands: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
            type: 3,
        },
        segment: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
            type: 4,
        },
        hub: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
            type: 5,
        },
        region: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
            type: 6,
        },
        territory: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
            type: 7,
        },
        grade: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
            type: 9,
        },
    },
    expanseSetting: {
        expanseModal: {
            flag: false,
            data: {}
        },
        expanseType: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
        },
        approvalChain: {
            currentPage: PAGINATION.CURRENT_PAGE,
            limit: PAGINATION.LIMIT,
            search: '',
        },
    },
    subCompanyFilters: {
        search: '',
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        filter: {
            type: {value: 'active', label: 'Active'}
        },
    },
    jobs: {
        search: '',
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        location: null,
        openingDate: null,
        expireDate: null,
        jobType: null,
    },

    /** employee route map filters */
    employeeRouteFilter: {
        date: new Date(),
        user: null,
    },
    mheProductivity : {editData : null},
    liveDashboardFilter: {
        search: "",
        date: new Date()
    },
    leaveBalance: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importEmployee: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importAttendance: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importBudget: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importSingleAttendance: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    updateEmployee: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importCompensation: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    updateCompensation: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    updateFullBonus: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importLeaveBalance: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    attritionRreport: {
        startDate: monthStart,
        endDate: monthEnd,
    },
    importLeavePolicy: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importEmployeeExit: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importPersonalDocument: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importLocationUpdate: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importSubLocation: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importEmpStatus: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importSubCompany: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importLocation: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importBankDetails: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importActiveEmployee: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    empFieldCategory: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    empFieldDepartment: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    empFieldSubDepartment: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    empFieldJobTitle: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importAccessLevel: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    empFieldPersonalDocument: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    empFieldDegree: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    empFieldRelationship: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    empFieldEmployeeStatus: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    empFieldEmployeeExit: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    empFieldLocationActivity: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    importStatutory: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    empFieldLetterType: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    orgBusiness: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    orgCostCenter: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    orgBands: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    orgGrade: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    orgSegment: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    orgHub: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    orgRegion: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    orgTerritory: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    orgZone: {
        search: '',
        filter: {},
        startDate: monthStart,
        endDate: new Date(),
        currentPage: PAGINATION.CURRENT_PAGE,
        user: null,
        limit: PAGINATION.LIMIT,
    },
    openTimelineFlag: false,
    clientFilter: {
        search: '',
        isDisable: {value: false, label: 'Active Clients'},
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    clientModal: {
        flag: false,
        data: {}
    },
    myProdRequest: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: startDate,
        endDate: endDate,
        status: {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
        search: '',
    },
    mheProdFilter: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: startDate,
        endDate: endDate,
        location : null,
        search: '',
        // status: {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
    },
    productivityApproval: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: startDate,
        endDate: endDate,
        status: {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
        search: '',
    },
    workArea: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    handlingUnit: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
    },
    calenderView: {
        date: new Date(),
    },
    productivityByShift: {
        startDate: startDate,
        endDate: endDate,
        location: null,
        handlingUnit: null,
        shift: null
    },
    productivityByLocation: {
        startDate: startDate,
        endDate: endDate,
        location: null,
        handlingUnit: null,
        shift: null
    },
    dashBoardHistory: getLocal('u_dsr') ? getLocal('u_dsr') : 'grid',
    expenseAdvanceRequest: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        startDate: previousMonth,
        endDate: endDate,
        reqStartDate: previousMonth,
        reqEndDate: endDate,
        user: '',
        status: {value: 1, label: 'Pending'},
        paymentType: ''
    },
    addAdvanceRequest: null,
    refundAmount: null,
    viewRequestDetails: null,
    transactionHistory: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        year: getCurrentYear(),
        filter: {
            startDate: null,
            endDate: null,
        }
    },
    empWalletList: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        user: '',
    },
    assetsFilter: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: 1
    },
    headCountBudgetReport: {
        startDate: yearStart,
        endDate: yearEnd,
        type: 1,
    },
    //Penalty Removal Report
    penaltyRemovalReport: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        filter: {},
        startDate: yearStart,
        endDate: yearEnd,
    },
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'SOCKET_CONNECTION': {
            return {...state, socketId: action.payload};
        }
        case 'AUTHENTICATE': {
            const data = {}
            if (action.payload) data._id = action.payload._id
            return {...state, ...data};
        }
        case 'GET_HRMS_MASTER_DATA': {
            const probationId = action.payload.employeeStatusList.find(_ => _.slug?.toLowerCase() === 'probation')?._id || null
            const internShipId = action.payload.employeeStatusList.find(_ => _.slug?.toLowerCase() === 'internship')?._id || null
            const probationFilter = probationId ? {employeeStatus: [probationId, internShipId]} : {}
            return {
                ...state,
                employeeProbation: {
                    ...state.employeeProbation,
                    filter: {...state.employeeProbation.filter, ...probationFilter}
                }
            };
        }
        /** * My profile Actions */
        case 'FILTER_JOB_INFORMATION': {
            return {...state, jobInformation: {...state.jobInformation, ...action.payload}};
        }
        case 'FILTER_AGREEMENT': {
            return {...state, agreement: {...state.agreement, ...action.payload}};
        }
        case 'FILTER_COMPENSATION': {
            return {...state, compensation: {...state.compensation, ...action.payload}};
        }
        case 'FILTER_MY_EXIT': {
            return {...state, myExit: {...state.myExit, ...action.payload}};
        }
        case 'FILTER_PROBATION': {
            return {...state, probation: {...state.probation, ...action.payload}};
        }
        case 'FILTER_BANK_INFORMATION': {
            return {...state, bankInformation: {...state.bankInformation, ...action.payload}};
        }
        case 'FILTER_MY_PROFILE_REQUEST': {
            return {...state, myProfileUpdateRequest: {...state.myProfileUpdateRequest, ...action.payload}};
        }

        /** * Employee Actions */
        case 'FILTER_EMPLOYEE_DIRECTORY': {
            return {...state, employeeDirectory: {...state.employeeDirectory, ...action.payload}};
        }
        case 'FILTER_ESSL_DEVICE': {
            return {...state, esslDeviceFilter: {...state.esslDeviceFilter, ...action.payload}};
        }
        case 'FILTER_EMPLOYEE_LIST': {
            return {...state, employeeList: {...state.employeeList, ...action.payload}};
        }
        case 'FILTER_EMPLOYEE_PROBATION': {
            const employeeProbation = {...state.employeeProbation}
            if (action?.payload?.empStatus) {
                employeeProbation.filter.employeeStatus = action?.payload?.empStatus
                delete action?.payload?.empStatus
            }
            sendData('hrms|reports|probation|list', {...state.employeeProbation, ...action.payload});
            return {...state, employeeProbation: {...state.employeeProbation, ...action.payload}};
        }
        case 'FILTER_EMPLOYEE_EXIT': {
            sendData('hrms|master|resignation|filter', {...state.employeeExit, ...action.payload});
            return {...state, employeeExit: {...state.employeeExit, ...action.payload}};
        }
        case 'FILTER_EMPLOYEE_AGREEMENT': {
            // sendData('hrms|reports|agreement|list', {...state.employeeAgreement, ...action.payload});
            return {...state, employeeAgreement: {...state.employeeAgreement, ...action.payload}};
        }
        case 'FILTER_EMPLOYEE_COMPENSATION': {
            sendData('hrms|reports|compensation|list', {...state.employeeCompensation, ...action.payload});
            return {...state, employeeCompensation: {...state.employeeCompensation, ...action.payload}};
        }
        case 'FILTER_EMPLOYEE_COMPENSATION_GRID': {
            sendData('hrms|reports|compensation|graph|list', {...state.employeeCompensationGrid, ...action.payload});
            return {...state, employeeCompensationGrid: {...state.employeeCompensationGrid, ...action.payload}};
        }
        case 'FILTER_PROFILE_REQUEST': {
            return {...state, profileUpdateRequest: {...state.profileUpdateRequest, ...action.payload}};
        }
        case 'FILTER_EXIT_REQUEST': {
            return {...state, employeeExitRequest: {...state.employeeExitRequest, ...action.payload}};
        }
        case 'FILTER_REVOKE_REQUEST': {
            return {...state, employeeRevokeRequest: {...state.employeeRevokeRequest, ...action.payload}};
        }
        case 'FULL_AND_FINAL_SETTLEMENT': {
            return {...state, fullAndFinalSettlement: {...state.fullAndFinalSettlement, ...action.payload}};
        }
        case 'FULL_AND_FINAL_SETTLEMENT_FOR_STEP_ONE': {
            return {
                ...state,
                fullAndFinalSettlementForStep1: {...state.fullAndFinalSettlementForStep1, ...action.payload}
            };
        }
        case 'FULL_AND_FINAL_SETTLEMENT_IN_EMPList': {
            return {
                ...state,
                fullAndFinalSettlementInEmpList: {...state.fullAndFinalSettlementInEmpList, ...action.payload}
            };
        }
        case 'FILTER_LEAVE_ASSIGNED': {
            return {...state, leaveAssigned: {...state.leaveAssigned, ...action.payload}};
        }
        case 'FILTER_LEAVE_ACCRUAL_DETAIL': {
            return {...state, leaveAccrualDetail: {...state.leaveAccrualDetail, ...action.payload}};
        }

        /** * Attendance Actions */
        case 'FILTER_MY_ATTENDANCE': {
            return {...state, myAttendance: {...state.myAttendance, ...action.payload}};
        }
        case 'FILTER_EMPLOYEE_ATTENDANCE': {
            return {...state, employeeAttendance: {...state.employeeAttendance, ...action.payload}};
        }
        case 'FILTER_ATTENDANCE_USER_VERIFICATION': {
            return {...state, attendanceUserVerification: {...state.attendanceUserVerification, ...action.payload}};
        }
        case 'FILTER_ATTENDANCE_VERIFICATION': {
            return {...state, attendanceVerification: {...state.attendanceVerification, ...action.payload}};
        }
        case 'FILTER_MY_STATUS_REPORT': {
            return {...state, myStatusReport: {...state.myStatusReport, ...action.payload}};
        }
        case 'FILTER_EMPLOYEE_STATUS_REPORT': {
            return {...state, employeeStatusReport: {...state.employeeStatusReport, ...action.payload}};
        }

        case 'FILTER_ATTENDANCE_REGULARIZATION': {
            return {...state, attendanceRegularization: {...state.attendanceRegularization, ...action.payload}};
        }
        case 'FILTER_WORKING_DAY': {
            return {...state, workingDay: {...state.workingDay, ...action.payload}};
        }
        case 'FILTER_NON_WORKING_DAY': {
            return {...state, nonWorkingDay: {...state.nonWorkingDay, ...action.payload}};
        }
        case 'FILTER_GEO_FENCING': {
            return {...state, geoFencing: {...state.geoFencing, ...action.payload}};
        }
        case 'FILTER_BIOMETRICS': {
            return {...state, biometrics: {...state.biometrics, ...action.payload}};
        }
        case 'FILTER_BIOMETRICS_USER': {
            return {...state, biometricsUser: {...state.biometricsUser, ...action.payload}};
        }
        case 'FILTER_SHIFT_SCHEDULER': {
            return {...state, shiftScheduler: {...state.shiftScheduler, ...action.payload}};
        }
        case 'FILTER_SHIFT_CALENDAR': {
            return {...state, shiftCalendar: {...state.shiftCalendar, ...action.payload}};
        }
        case 'INBOX_COMMEN_FILTER': {
            return {...state, inboxCommenAttendance: {...state.inboxCommenAttendance, ...action.payload}};
        }

        /** ! Old Actions */
        case 'SET_MY_REQUEST': {
            return {...state, myRequest: {...state.myRequest, ...action.payload}};
        }
        case 'SET_SHIFT_CHANGE_REQUEST': {
            return {...state, shiftChangeRequest: {...state.shiftChangeRequest, ...action.payload}};
        }
        case 'SET_HOLIDAY_REQUEST': {
            return {...state, holidayRequest: {...state.holidayRequest, ...action.payload}};
        }
        case 'SET_EMP_SHIFT_CHANGE_REQUEST': {
            return {...state, empShiftChangeRequest: {...state.empShiftChangeRequest, ...action.payload}};
        }
        case 'SET_MY_OD_REQUEST_FILTER': {
            return {...state, myOdRequest: {...state.myOdRequest, ...action.payload}};
        }
        case 'SET_OD_REQUEST_FILTER': {
            return {...state, odRequest: {...state.odRequest, ...action.payload}};
        }
        case 'SET_EARLY_OUT_FILTER': {
            return {...state, myEarlyOutFilters: {...state.myEarlyOutFilters, ...action.payload}};
        }
        case 'SET_LATE_IN_FILTER': {
            return {...state, lateInFilters: {...state.lateInFilters, ...action.payload}};
        }
        case 'SET_MY_LATE_IN_FILTER': {
            return {...state, myLateInFilters: {...state.myLateInFilters, ...action.payload}};
        }
        case 'SET_ALL_EARLY_OUT_FILTER': {
            return {...state, earlyOutFilters: {...state.earlyOutFilters, ...action.payload}};
        }
        case 'SET_MONTHLY_ATTENDANCE': {
            return {...state, monthlyAttendance: {...state.monthlyAttendance, ...action.payload}};
        }
        // import bulk ===========================
        case 'WEEKEND_POLICY': {
            return {...state, weekendpolicy: {...state.weekendpolicy, ...action.payload}};
        }
        case 'SHIFT_CHANGE_REQUEST': {
            return {...state, ShiftRequestPolicy: {...state.ShiftRequestPolicy, ...action.payload}};
        }
        case 'PENALISATION': {
            return {...state, PenalisationPolicy: {...state.PenalisationPolicy, ...action.payload}};
        }
        case 'ON_DUTY': {
            return {...state, OnDutyPolicy: {...state.OnDutyPolicy, ...action.payload}};
        }
        case 'OVERTIME': {
            return {...state, OverTimePolicy: {...state.OverTimePolicy, ...action.payload}};
        }
        case 'COMPOFF': {
            return {...state, CompOffPolicy: {...state.CompOffPolicy, ...action.payload}};
        }
        case 'LEAVE': {
            return {...state, LeavePolicy: {...state.LeavePolicy, ...action.payload}};
        }
        case 'POLICY_DOCUMENT': {
            return {...state, ImportPolicyDocument: {...state.ImportPolicyDocument, ...action.payload}};
        }
        case 'REFERRAL': {
            return {...state, ImportReferrelPolicy: {...state.ImportReferrelPolicy, ...action.payload}};
        }
        case 'SET_QUERY_BUILDER_REPORT': {
            return {...state, queryBuilder: action.payload};
        }
        case 'SET_QUERY_BUILDER_FILTER': {
            return {...state, queryBuilderFilter: action.payload};
        }
        case 'SET_ATTENDANCE_VERIFICATION_REPORT': {
            return {...state, attendanceVerificationReport: {...state.attendanceVerificationReport, ...action.payload}};
        }
        case 'SET_MASTER_LOCATION_LIST': {
            return {...state, masterLocation: {...state.masterLocation, ...action.payload}};
        }
        case 'SET_EMPLOYEE_LOGIN_IP': {
            return {...state, employeeLoginIP: {...state.employeeLoginIP, ...action.payload}};
        }
        case 'SET_MASTER_CATEGORY_LIST': {
            return {...state, masterCategory: {...state.masterCategory, ...action.payload}};
        }
        case 'SET_LOCATION_BILLING_TYPE': {
            return {...state, locationBillingType: {...state.locationBillingType, ...action.payload}};
        }
        case 'SET_INDUSTRY_LIST': {
            return {...state, industryList: {...state.industryList, ...action.payload}};
        }
        case 'SET_MASTER_ACTIVITY_LIST': {
            return {...state, masterActivity: {...state.masterActivity, ...action.payload}};
        }
        case 'SET_MASTER_DEPARTMENT_LIST': {
            return {...state, masterDepartment: {...state.masterDepartment, ...action.payload}};
        }
        case 'SET_MASTER_SUB_DEPARTMENT_LIST': {
            return {...state, masterSubDepartment: {...state.masterSubDepartment, ...action.payload}};
        }
        case 'SET_MASTER_CLOCK_IN_METHOD_LIST': {
            return {...state, masterClockInMethod: {...state.masterClockInMethod, ...action.payload}};
        }
        case 'SET_MASTER_ATTENDANCE_TYPE_LIST': {
            return {...state, masterAttendanceType: {...state.masterAttendanceType, ...action.payload}};
        }
        case 'SET_MASTER_ATTENDANCE_REASON_LIST': {
            return {...state, masterAttendanceReason: {...state.masterAttendanceReason, ...action.payload}};
        }
        case 'SET_MASTER_IDPROOF_LIST': {
            return {...state, masterIDProof: {...state.masterIDProof, ...action.payload}};
        }
        case 'SET_DEGREE_LIST': {
            return {...state, masterDegree: {...state.masterDegree, ...action.payload}};
        }
        case 'SET_RELATIONSHIP_LIST': {
            return {...state, masterRelationship: {...state.masterRelationship, ...action.payload}};
        }
        case 'SET_EMPLOYEE_STATUS_LIST': {
            return {...state, masterEmployeeStatus: {...state.masterEmployeeStatus, ...action.payload}};
        }
        case 'SET_JOB_TITLE_LIST': {
            return {...state, masterJobTitle: {...state.masterJobTitle, ...action.payload}};
        }
        case 'SET_MASTER_EMPLOYEE_EXIT_LIST': {
            return {...state, masterEmployeeExit: {...state.masterEmployeeExit, ...action.payload}};
        }
        case 'SET_MASTER_SHIFT_LIST': {
            return {...state, masterShift: {...state.masterShift, ...action.payload}};
        }
        case 'SET_MASTER_SHIFT_REQUEST_LIST': {
            return {...state, masterShiftRequest: {...state.masterShiftRequest, ...action.payload}};
        }
        case 'SET_MASTER_ON_DUTY_LIST': {
            return {...state, masterOnduty: {...state.masterOnduty, ...action.payload}};
        }
        case 'SET_MASTER_WEEKEND_LIST': {
            return {...state, masterWeekend: {...state.masterWeekend, ...action.payload}};
        }
        case 'SET_MASTER_PENALISATION_LIST': {
            return {...state, masterPenalisation: {...state.masterPenalisation, ...action.payload}};
        }
        case 'SET_SHIFT_ASSIGNED_LIST': {
            return {...state, shiftAssigned: {...state.shiftAssigned, ...action.payload}};
        }
        case 'SET_MASTER_BREAK_LIST': {
            return {...state, masterBreak: {...state.masterBreak, ...action.payload}};
        }
        case 'SET_WORK_DIARY_ASSIGNED_LIST': {
            return {...state, workDiaryAssigned: {...state.workDiaryAssigned, ...action.payload}};
        }
        case 'SET_MASTER_ACCESS_LEVEL_LIST': {
            return {...state, masterAccessLevel: {...state.masterAccessLevel, ...action.payload}};
        }

        case 'SET_ACCESS_LEVEL_UNASSIGNED_LIST': {
            return {...state, accessLevelUnAssigned: {...state.accessLevelUnAssigned, ...action.payload}};
        }
        case 'SET_EMPLOYEE_EXIT_TASK_LIST': {
            return {...state, employeeExitFilter: {...state.employeeExitFilter, ...action.payload}};
        }
        case 'SET_ONBOARDING_TEMPLATE_LIST': {
            return {...state, onboardingTemplate: {...state.onboardingTemplate, ...action.payload}};
        }
        case 'SET_ONBOARDING_CANDIDATE_LIST': {
            return {...state, onboardingCandidateList: {...state.onboardingCandidateList, ...action.payload}};
        }
        case 'SET_ONBOARDING_USER_LIST': {
            return {...state, onboardingUserList: {...state.onboardingUserList, ...action.payload}};
        }
        case 'SET_ONBOARDING_USER_TASK_LIST': {
            return {...state, onboardingUserTaskList: {...state.onboardingUserTaskList, ...action.payload}};
        }
        case 'SET_ONBOARDING_FIELD_LIST': {
            return {...state, onBoardingFields: {...state.onBoardingFields, ...action.payload}};
        }
        case 'SET_ONBOARDING_TASKS_LIST': {
            return {...state, onboardingTasks: {...state.onboardingTasks, ...action.payload}};
        }
        case 'SET_POLICY_DOCUMENTS_LIST': {
            return {...state, policyDocuments: {...state.policyDocuments, ...action.payload}};
        }
        case 'SET_REFERRAL_POLICY_LIST': {
            return {...state, referralPolicy: {...state.referralPolicy, ...action.payload}};
        }
        case 'SET_PRAISE_SETTINGS_LIST': {
            return {...state, praiseSettings: {...state.praiseSettings, ...action.payload}};
        }
        case 'SET_FEEDBACK_SETTINGS_LIST': {
            return {...state, feedbackTypeSetting: {...state.feedbackTypeSetting, ...action.payload}};
        }
        case 'SET_CORE_VALUE_LIST': {
            return {...state, coreValues: {...state.coreValues, ...action.payload}};
        }
        case 'SET_TIMELINE_PRAISE_LIST': {
            return {...state, timelinePraise: {...state.timelinePraise, ...action.payload}};
        }
        case 'SET_TIMELINE_FEEDBACK_LIST': {
            return {...state, timelineFeedback: {...state.timelineFeedback, ...action.payload}};
        }
        case 'SET_TIMELINE_FEEDBACK_REQUEST_LIST': {
            return {...state, timelineFeedbackRequests: {...state.timelineFeedbackRequests, ...action.payload}};
        }
        case 'SET_TIMELINE_INTERNAL_NOTE_LIST': {
            return {...state, timelineInternalNotes: {...state.timelineInternalNotes, ...action.payload}};
        }
        case 'SET_ABSENT_PRESENT': {
            return {...state, absentPresent: {...state.absentPresent, ...action.payload}};
        }
        case 'SET_ABSENT_PRESENT_VIEW': {
            setLocal('u_apv', action.payload);
            return {...state, absentPresentView: action.payload};
        }
        case 'SET_HOLIDAY_FILTER': {
            return {...state, holidayAllFilter: {...state.holidayAllFilter, ...action.payload}};
        }
        case 'SET_HOLIDAY_MASTER_FILTER': {
            return {...state, holidayMasterAllFilter: {...state.holidayMasterAllFilter, ...action.payload}};
        }
        case 'SET_OT_POLICY': {
            return {...state, OTPolicy: {...state.OTPolicy, ...action.payload}};
        }
        case 'SET_OVERTIME_ADD': {
            return {...state, overTimeAdd: {...state.overTimeAdd, ...action.payload}};
        }
        case 'SET_MY_OVERTIME': {
            return {...state, myOverTime: {...state.myOverTime, ...action.payload}};
        }
        case 'SET_OVERTIME': {
            return {...state, overTime: {...state.overTime, ...action.payload}};
        }
        case 'SET_PAY_CODE': {
            return {...state, payCode: {...state.payCode, ...action.payload}};
        }
        case 'SET_COMP_OFF_POLICY_FILTER': {
            return {...state, compOffPolicyFilters: {...state.compOffPolicyFilters, ...action.payload}};
        }
        case 'SET_MY_COMP_OFF_FILTER': {
            return {...state, myCompOffFilters: {...state.myCompOffFilters, ...action.payload}};
        }
        case 'SET_COMP_OFF_FILTER': {
            return {...state, compOffFilters: {...state.compOffFilters, ...action.payload}};
        }
        case 'SET_COMP_OFF_ADD': {
            return {...state, compOffAdd: {...state.compOffAdd, ...action.payload}};
        }

        /* REPORT & MY-REPORT END*/
        case 'SET_PRESENT_DAY_FILTER': {
            return {...state, presentDefault: {...state.presentDefault, ...action.payload}};
        }
        case 'SET_NEW_JOINEE_REPORT': {
            return {...state, newJoineesReport: {...state.newJoineesReport, ...action.payload}};
        }
        case 'SET_EARLY_OUT_SUMMERY_REPORT': {
            return {...state, earlyOutSummaryReport: {...state.earlyOutSummaryReport, ...action.payload}};
        }
        case 'SET_EARLY_OUT_USER_SUMMERY_REPORT': {
            return {...state, earlyOutUserSummaryReport: {...state.earlyOutUserSummaryReport, ...action.payload}};
        }
        case 'SET_LATE_IN_SUMMERY_REPORT': {
            return {...state, lateInSummaryReport: {...state.lateInSummaryReport, ...action.payload}};
        }
        case 'SET_INBOX_AUDIT_LOG_REPORT': {
            return {...state, inboxAuditLog: {...state.inboxAuditLog, ...action.payload}};
        }
        case 'SET_ATTENDANCE_WITH_BREAK_SUMMERY_REPORT': {
            return {...state, attendanceALLSummaryReport: {...state.attendanceALLSummaryReport, ...action.payload}};
        }
        case 'SET_WAGES_STATE': {
            return {...state, wagesState: {...state.wagesState, ...action.payload}};
        }
        case 'SET_WAGES_STATE_DETAIL': {
            return {...state, wagesStateDetail: {...state.wagesStateDetail, ...action.payload}};
        }
        case 'SET_WAGES_EMPLOYMENT': {
            return {...state, wagesEmployment: {...state.wagesEmployment, ...action.payload}};
        }
        case 'SET_WAGES_WORKER': {
            return {...state, wagesWorker: {...state.wagesWorker, ...action.payload}};
        }
        case 'SET_WAGES_ZONE': {
            return {...state, wagesZone: {...state.wagesZone, ...action.payload}};
        }
        case 'SET_STATUS_REPORT_EMPLOYEE': {
            return {...state, empStatusReport: {...state.empStatusReport, ...action.payload}};
        }
        case 'SET_TAX_REGIME_REPORT_EMPLOYEE': {
            return {...state, empTaxRegimeReport: {...state.empTaxRegimeReport, ...action.payload}};
        }
        case 'SET_TAX_REGIME_FINANCIAL_EMPLOYEE': {
            return {...state, empTaxRegimeFinancialFilter: {...state.empTaxRegimeFinancialFilter, ...action.payload}};
        }
        case 'SET_INSURANCE_REPORT': {
            return {...state, empInsuranceReport: {...state.empInsuranceReport, ...action.payload}};
        }
        case 'SET_YEARLY_SUMMARY_REPORT': {
            return {...state, yearlySummaryReport: {...state.yearlySummaryReport, ...action.payload}};
        }
        case 'SET_COVID_REPORT': {
            return {...state, empCovidReport: {...state.empCovidReport, ...action.payload}};
        }
        case 'SET_INSURANCE_TYPE_FILTER': {
            return {...state, empInsuranceTypeFilter: {...state.empInsuranceTypeFilter, ...action.payload}};
        }
        case 'SET_PERSONAL_REPORT_EMPLOYEE': {
            return {...state, empPersonalReport: {...state.empPersonalReport, ...action.payload}};
        }
        case 'SET_PROFILE_COMPLETION_REPORT': {
            return {...state, profileCompletion: {...state.profileCompletion, ...action.payload}};
        }
        case 'SET_PERSONAL_DOCUMENT_REPORT_EMPLOYEE': {
            return {...state, empPersonalDocumentReport: {...state.empPersonalDocumentReport, ...action.payload}};
        }
        case 'SET_EMPLOYEE_EXIT_REPORT': {
            return {...state, empExitReport: {...state.empExitReport, ...action.payload}};
        }
        case 'SET_EMERGENCY_REPORT_EMPLOYEE': {
            return {...state, empEmergencyReport: {...state.empEmergencyReport, ...action.payload}};
        }
        case 'SET_ATTENDANCE_TYPE': {
            return {...state, attendanceType: {...state.attendanceType, ...action.payload}};
        }
        case 'SET_STATUTORY_REPORT_EMPLOYEE': {
            return {...state, statutoryReport: {...state.statutoryReport, ...action.payload}};
        }
        case 'SET_TRANSFER_REPORT_EMPLOYEE': {
            return {...state, empTransferReport: {...state.empTransferReport, ...action.payload}};
        }
        case 'SET_ORG_REPORT': {
            return {...state, orgReport: {...state.orgReport, ...action.payload}};
        }
        case 'SET_DOWNLOAD_REQUEST_REPORT': {
            return {...state, downloadRequestReport: {...state.downloadRequestReport, ...action.payload}};
        }
        case 'SET_UPLOAD_REPORT': {
            return {...state, uploadReport: {...state.uploadReport, ...action.payload}};
        }
        case 'SET_ATTENDANCE_SUMMARY_REPORT': {
            return {...state, attendanceSummaryReport: {...state.attendanceSummaryReport, ...action.payload}};
        }
        case 'SET_COMPANY_HOURS_REPORT': {
            return {...state, companyHoursReport: {...state.companyHoursReport, ...action.payload}};
        }
        case 'SET_CTC_REPORT': {
            return {...state, ctcReport: {...state.ctcReport, ...action.payload}};
        }
        case 'SET_DEPARTMENT_DETAILS_REPORT': {
            return {...state, deptDetailsReport: {...state.deptDetailsReport, ...action.payload}};
        }
        case 'SET_DEPARTMENT_REPORT': {
            return {...state, deptReport: {...state.deptReport, ...action.payload}};
        }
        case 'SET_JOBTITLE_DETAILS_REPORT': {
            return {...state, jobTitleDetailsReport: {...state.jobTitleDetailsReport, ...action.payload}};
        }
        case 'SET_JOBTITLE_REPORT': {
            return {...state, jobTitleReport: {...state.jobTitleReport, ...action.payload}};
        }
        case 'SET_LOCATION_DETAILS_REPORT': {
            return {...state, locationDetailsReport: {...state.locationDetailsReport, ...action.payload}};
        }
        case 'SET_SUB_LOCATION_REPORT': {
            return {...state, subLocationReport: {...state.subLocationReport, ...action.payload}};
        }
        case 'SET_LOCATION_REPORT': {
            return {...state, locationReport: {...state.locationReport, ...action.payload}};
        }
        case 'SET_EXPERIENCE_DETAILS_REPORT': {
            return {...state, experienceDetailsReport: {...state.experienceDetailsReport, ...action.payload}};
        }
        case 'SET_EXPERIENCE_REPORT': {
            return {...state, experienceReport: {...state.experienceReport, ...action.payload}};
        }
        case 'SET_GENDER_DETAILS_REPORT': {
            return {...state, genderDetailsReport: {...state.genderDetailsReport, ...action.payload}};
        }
        case 'SET_GENDER_REPORT': {
            return {...state, genderReport: {...state.genderReport, ...action.payload}};
        }
        case 'SET_DAILY_ATTENDANCE_REPORT': {
            return {...state, dailyAttendanceReport: {...state.dailyAttendanceReport, ...action.payload}};
        }
        case 'SET_ATTENDANCE_REPORT_DASHBOARD': {
            return {...state, attendanceReportDashBoard: {...state.attendanceReportDashBoard, ...action.payload}};
        }
        case 'SET_MHE_REPORT_DASHBOARD': {
            return {...state, mheDashboard: {...state.mheDashboard, ...action.payload}};
        }
        case 'SET_BUDGET_REPORT': {
            return {...state, budgetReport: {...state.budgetReport, ...action.payload}};
        }
        case 'SET_DAILY_ATTENDANCE_LOCATION_REPORT': {
            return {
                ...state,
                dailyAttendanceLocationReport: {...state.dailyAttendanceLocationReport, ...action.payload}
            };
        }
        case 'SET_CUSTOM_SABBATICAL_REPORT': {
            return {
                ...state,
                customReportWithSabbaticalLeave: {...state.customReportWithSabbaticalLeave, ...action.payload}
            };
        }
        case 'SET_DAILY_ATTENDANCE_BY_DEPARTMENT_LOCATION_REPORT': {
            return {
                ...state,
                dailyAttendanceByDepartmentLocationReport: {...state.dailyAttendanceByDepartmentLocationReport, ...action.payload}
            };
        }
        case 'SET_EMPLOYEE_STATISTICS_PAYROLL_REPORT': {
            return {
                ...state,
                employeeStatisticsPayrollReport: {...state.employeeStatisticsPayrollReport, ...action.payload}
            };
        }
        case 'PENALISATION_LIST_PAYROLL': {
            return {...state, penalisationListPayroll: {...state.penalisationListPayroll, ...action.payload}};
        }
        case 'SET_EMPLOYEE_STATISTICS_LOGIN_REPORT': {
            return {
                ...state,
                employeeStatisticsLoginReport: {...state.employeeStatisticsLoginReport, ...action.payload}
            };
        }
        case 'SET_MINIMUM_WAGES_REPORT': {
            return {...state, minimumWagesReport: {...state.minimumWagesReport, ...action.payload}};
        }
        case 'SET_MINIMUM_WAGES_REPORT_DETAIL': {
            return {...state, minimumWagesReportDetail: {...state.minimumWagesReportDetail, ...action.payload}};
        }
        case 'SET_BIOMETRIC_PUNCHES_REPORT': {
            return {...state, biometricPunchesReport: {...state.biometricPunchesReport, ...action.payload}};
        }
        case 'SET_BIOMETRIC_INFO_REPORT': {
            return {...state, biometricPunchesInfo: {...state.biometricPunchesInfo, ...action.payload}};
        }
        case 'SET_CLOCK-IN_METHOD_REPORT': {
            return {...state, clockINMethodReport: {...state.clockINMethodReport, ...action.payload}};
        }
        case 'SET_EMPLOYEE_ACTIVITY_REPORT': {
            return {...state, liveTrackingActivityReport: {...state.liveTrackingActivityReport, ...action.payload}};
        }
        case 'SET_BIOMETRIC_DEVICE_REPORT': {
            return {...state, biometricDevice: {...state.biometricDevice, ...action.payload}};
        }
        case 'SET_BIOMETRIC_LOCATION_REPORT': {
            return {...state, biometricLocation: {...state.biometricLocation, ...action.payload}};
        }
        case 'SET_PERFORMANCE_REPORT': {
            return {...state, performanceReport: {...state.performanceReport, ...action.payload}};
        }
        case 'SET_OVERTIME_INFO_REPORT': {
            return {...state, overtimeReport: {...state.overtimeReport, ...action.payload}};
        }
        case 'SET_EMPLOYEE_OVERTIME_REPORT': {
            return {...state, extraHours: {...state.extraHours, ...action.payload}};
        }
        case 'SET_EMPLOYEE_INTERNSHIP_PROBATION_STATUS': {
            return {...state, internshipProbationStatus: {...state.internshipProbationStatus, ...action.payload}};
        }
        case 'SET_CONSECUTIVE_EXTRA_TIME': {
            return {...state, consecutiveExtraTime: {...state.consecutiveExtraTime, ...action.payload}};
        }
        case 'SET_ZONE_INFO_REPORT': {
            return {...state, zoneInfo: {...state.zoneInfo, ...action.payload}};
        }
        case 'SET_CLUSTER': {
            return {...state, clusterReport: {...state.clusterReport, ...action.payload}};
        }
        case 'SET_BIOMETRIC_ASSIGN_REPORT': {
            return {...state, biometricAssignReport: {...state.biometricAssignReport, ...action.payload}};
        }
        case 'SET_BIOMETRIC_RECORDS': {
            return {...state, biometricRecords: {...state.biometricRecords, ...action.payload}};
        }
        case 'SET_BIOMETRIC_FAIL_RECORD': {
            return {...state, biometricFailRecord: {...state.biometricFailRecord, ...action.payload}};
        }

        case 'FILTER_LETTER_TYPE': {
            return {...state, documentLetter: {...state.letterType, ...action.payload}};
        }
        case 'FILTER_EMPLOYEE_LETTER': {
            return {...state, employeesLetter: {...state.employeesLetter, ...action.payload}};
        }
        case 'INSURANCE_INFO': {
            return {...state, insuranceInfo: {...state.insuranceInfo, ...action.payload}};
        }
        case 'UPDATE_INSURANCE_INFO': {
            return {...state, insuranceInfo: action.payload};
        }
        case 'FILTER_EMPLOYEE_SIGNATURE': {
            return {...state, signatureList: {...state.signatureList, ...action.payload}};
        }
        case 'SET_DAILY_LEAVE_REPORT': {
            return {...state, dailyLeaveReport: {...state.dailyLeaveReport, ...action.payload}};
        }
        case 'SET_LEAVE_BOOKED_BALANCE_REPORT': {
            return {...state, leaveBookedBalancedReport: {...state.leaveBookedBalancedReport, ...action.payload}};
        }
        case 'SET_LEAVE_TYPE_WISE_REPORT': {
            return {...state, leaveTypeWiseReport: {...state.leaveTypeWiseReport, ...action.payload}};
        }
        case 'SET_ATTENDANCE_COUNT_REPORT': {
            return {...state, attendanceCount: {...state.attendanceCount, ...action.payload}};
        }
        case 'SET_LEAVE_ENCASHMENT_REPORT': {
            return {...state, leaveEnashmentReport: {...state.leaveEnashmentReport, ...action.payload}};
        }
        case 'SET_COMP_OFF_REPORT': {
            return {...state, compOffReport: {...state.compOffReport, ...action.payload}};
        }
        case 'SET_HELP_DESK_SETTING_FILTER': {
            return {...state, helpDesk: {...state.helpDesk, ...action.payload}}
        }
        case 'SET_ORG_STRUCTURE_SETTING_FILTER': {
            return {...state, orgStructure: {...state.orgStructure, ...action.payload}}
        }

        case 'SET_EXPANSE_SETTING_FILTER': {
            return {...state, expanseSetting: {...state.expanseSetting, ...action.payload}}
        }
        case 'SET_EMPLOYEE_ROUTE_FILTER': {
            return {...state, employeeRouteFilter: {...state.employeeRouteFilter, ...action.payload}};
        }
        case 'SET_LIVE_DASHBOARD_FILTER': {
            return {...state, liveDashboardFilter: {...state.liveDashboardFilter, ...action.payload}};
        }
        case 'SET_TIMELINE_FLAG': {
            return {...state, openTimelineFlag: action.payload}
        }
        case 'SET_CLIENT_MODAL': {
            return {...state, clientModal: action.payload}
        }
        case 'SET_CLIENT_FILTER': {
            return {...state, clientFilter: {...state.clientFilter, ...action.payload}}
        }
        case 'LEAVE_BALANCE_FILTER': {
            return {...state, leaveBalance: {...state.leaveBalance, ...action.payload}};
        }
        case 'IMPORT_EMPLOYEE_FILTER': {
            return {...state, importEmployee: {...state.importEmployee, ...action.payload}};
        }
        case 'IMPORT_ATTENDANCE_FILTER': {
            return {...state, importAttendance: {...state.importAttendance, ...action.payload}};
        }
        case 'IMPORT_BUDGET_FILTER': {
            return {...state, importBudget: {...state.importBudget, ...action.payload}};
        }
        case 'IMPORT_SINGLE_ATTENDANCE_FILTER': {
            return {...state, importSingleAttendance: {...state.importSingleAttendance, ...action.payload}};
        }
        case 'UPDATE_EMPLOYEE_FILTER': {
            return {...state, updateEmployee: {...state.updateEmployee, ...action.payload}};
        }
        case 'IMPORT_COMPENSATION_FILTER': {
            return {...state, importCompensation: {...state.importCompensation, ...action.payload}};
        }
        case 'UPDATE_COMPENSATION_FILTER': {
            return {...state, updateCompensation: {...state.updateCompensation, ...action.payload}};
        }
        case 'UPDATE_FULL_BONUS_FILTER': {
            return {...state, updateFullBonus: {...state.updateFullBonus, ...action.payload}};
        }
        case 'IMPORT_LEAVE-BALANCE_FILTER': {
            return {...state, importData: {...state.importLeaveBalance, ...action.payload}};
        }
        case 'IMPORT_LEAVE_POLICY_FILTER': {
            return {...state, importData: {...state.importLeavePolicy, ...action.payload}};
        }
        case 'ATTRITION_REPORT': {
            return {...state, attritionRreport: {...state.attritionRreport, ...action.payload}};
        }
        case 'IMPORT_EMPLOYEE_EXIT_FILTER': {
            return {...state, importEmployeeExit: {...state.importEmployeeExit, ...action.payload}};
        }
        case 'IMPORT_LOCATION': {
            return {...state, importLocation: {...state.importLocation, ...action.payload}};
        }
        case 'IMPORT_LOCATION_UPDATE': {
            return {...state, importLocationUpdate: {...state.importLocationUpdate, ...action.payload}};
        }
        case 'IMPORT_SUB_LOCATION': {
            return {...state, importSubLocation: {...state.importSubLocation, ...action.payload}};
        }
        case 'IMPORT_EMPLOYEE_STATUS': {
            return {...state, importEmpStatus: {...state.importEmpStatus, ...action.payload}};
        }
        case 'IMPORT_SUB-COMPANY_FILTER': {
            return {...state, importSubCompany: {...state.importSubCompany, ...action.payload}};
        }
        case 'IMPORT_PERSONAL_DOCUMENT_FILTER': {
            return {...state, importPersonalDocument: {...state.importPersonalDocument, ...action.payload}};
        }
        case 'IMPORT_DATA_SELECT_RANGE': {
            return {...state, importDateRange: {...state.importDateRange, ...action.payload}};
        }
        case 'IMPORT_BANK_DETAILS_FILTER': {
            return {...state, importBankDetails: {...state.importBankDetails, ...action.payload}};
        }
        case 'IMPORT_ACTIVE_FILTER': {
            return {...state, importActiveEmployee: {...state.importActiveEmployee, ...action.payload}};
        }

        case 'EMP_FIELD_CATEGORY_FILTER': {
            return {...state, empFieldCategory: {...state.empFieldCategory, ...action.payload}};
        }
        case 'EMP_FIELD_DEPARTMENT_FILTER': {
            return {...state, empFieldDepartment: {...state.empFieldDepartment, ...action.payload}};
        }
        case 'EMP_FIELD_SUB_DEPARTMENT_FILTER': {
            return {...state, empFieldSubDepartment: {...state.empFieldSubDepartment, ...action.payload}};
        }
        case 'EMP_FIELD_JOB_TITLE_FILTER': {
            return {...state, empFieldJobTitle: {...state.empFieldJobTitle, ...action.payload}};
        }
        case 'IMPORT_ACCESS_LEVEL_FILTER': {
            return {...state, importAccessLevel: {...state.importAccessLevel, ...action.payload}};
        }
        case 'EMP_FIELD_PERSONAL_DOCUMENT_FILTER': {
            return {...state, empFieldPersonalDocument: {...state.empFieldPersonalDocument, ...action.payload}};
        }
        case 'EMP_FIELD_DEGREE_FILTER': {
            return {...state, empFieldDegree: {...state.empFieldDegree, ...action.payload}};
        }
        case 'EMP_FIELD_RELATIONSHIP_FILTER': {
            return {...state, empFieldRelationship: {...state.empFieldRelationship, ...action.payload}};
        }
        case 'EMP_FIELD_EMPLOYEE_STATUS_FILTER': {
            return {...state, empFieldEmployeeStatus: {...state.empFieldEmployeeStatus, ...action.payload}};
        }
        case 'EMP_FIELD_EMPLOYEE_EXIT_FILTER': {
            return {...state, empFieldEmployeeExit: {...state.empFieldEmployeeExit, ...action.payload}};
        }
        case 'EMP_FIELD_LOCATION_FILTER': {
            return {...state, empFieldLocationActivity: {...state.empFieldLocationActivity, ...action.payload}};
        }
        case 'EMP_FIELD_LETTER_FILTER': {
            return {...state, empFieldLetterType: {...state.empFieldLetterType, ...action.payload}};
        }
        case 'ORG_BUSINESS_FILTER': {
            return {...state, orgBusiness: {...state.orgBusiness, ...action.payload}};
        }
        case 'IMPORT_STATUTORY': {
            return {...state, importStatutory: {...state.importStatutory, ...action.payload}};
        }
        case 'ORG_COST_CENTER_FILTER': {
            return {...state, orgCostCenter: {...state.orgCostCenter, ...action.payload}};
        }
        case 'ORG_BANDS_FILTER': {
            return {...state, orgBands: {...state.orgBands, ...action.payload}};
        }
        case 'ORG_GRADE_FILTER': {
            return {...state, orgGrade: {...state.orgGrade, ...action.payload}};
        }
        case 'ORG_SEGMENT_FILTER': {
            return {...state, orgSegment: {...state.orgSegment, ...action.payload}};
        }
        case 'ORG_HUB_FILTER': {
            return {...state, orgHub: {...state.orgHub, ...action.payload}};
        }
        case 'ORG_REGION_FILTER': {
            return {...state, orgRegion: {...state.orgRegion, ...action.payload}};
        }
        case 'ORG_TERRITORY_FILTER': {
            return {...state, orgTerritory: {...state.orgTerritory, ...action.payload}};
        }
        case 'ORG_ZONE_FILTER': {
            return {...state, orgZone: {...state.orgZone, ...action.payload}};
        }
        case 'SET_SUB_COMPANY_FILTER': {
            return {...state, subCompanyFilters: {...state.subCompanyFilters, ...action.payload}};
        }
        case 'OTHER_DOCUMENT_FILTER': {
            return {...state, otherDocument: {...state.otherDocument, ...action.payload}};
        }
        case 'JOBS_FILTER': {
            return {...state, jobs: {...state.jobs, ...action.payload}};
        }
        case 'FILTER_EMPLOYEE_TREE': {
            return {...state, employeeTree: {...state.employeeTree, ...action.payload}};
        }
        case 'SET_BREAK_REPORT' : {
            return {...state, employeeBreakReport: {...state.employeeBreakReport, ...action.payload}};
        }
        case 'EMPLOYEE_HISTORY' : {
            return {...state, employeeHistory: {...state.employeeHistory, ...action.payload}};
        }
        case 'ACTIVITY_LOG_HISTORY' : {
            return {...state, activityLogHistory: {...state.activityLogHistory, ...action.payload}};
        }
        case 'SET_MY_PROD_REQUEST': {
            return {...state, myProdRequest: {...state.myProdRequest, ...action.payload}};
        }
        case 'SET_MHE_PROD_FILTER': {
            return {...state, mheProdFilter: {...state.mheProdFilter, ...action.payload}};
        }
        case 'SET_PROD_APPROVAL': {
            return {...state, productivityApproval: {...state.productivityApproval, ...action.payload}};
        }
        case 'SET_WORKAREA_LIST': {
            return {...state, workArea: {...state.workArea, ...action.payload}};
        }
        case 'SET_HANDLING_UNIT_LIST': {
            return {...state, handlingUnit: {...state.handlingUnit, ...action.payload}};
        }
        case 'SET_CALENDER_VIEW_FILTER': {
            return {...state, calenderView: {...state.calenderView, ...action.payload}};
        }
        case 'SET_PROD_BY_SHIFT': {
            return {...state, productivityByShift: {...state.productivityByShift, ...action.payload}};
        }
        case 'SET_PROD_BY_LOCATION': {
            return {...state, productivityByLocation: {...state.productivityByLocation, ...action.payload}};
        }
        case 'SET_DASHBOARD_REPORT_VIEW': {
            setLocal('u_dsr', action.payload);
            return {...state, dashBoardReportView: action.payload};
        }
        case 'SET_MHE_DASHBOARD_REPORT_VIEW': {
            setLocal('u_dsr', action.payload);
            return {...state, mheDashBoardView: action.payload};
        }
        case 'SET_EXPENSE_ADVANCE_REQ': {
            return {...state, expenseAdvanceRequest: {...state.expenseAdvanceRequest, ...action.payload}};
        }
        case 'SET_ADD_ADVANCE_REQ': {
            return {...state, addAdvanceRequest: {...state.addAdvanceRequest, ...action.payload}};
        }
        case 'SET_TRANSACTION_HISTORY': {
            return {...state, transactionHistory: {...state.transactionHistory, ...action.payload}};
        }
        case 'SET_EMP_WALLET_LIST': {
            return {...state, empWalletList: {...state.empWalletList, ...action.payload}};
        }
        case 'SET_REFUND_AMOUNT': {
            return {...state, refundAmount: {...state.refundAmount, ...action.payload}};
        }
        case 'SET_VIEW_REQ_DETAILS': {
            return {...state, viewRequestDetails: {...state.viewRequestDetails, ...action.payload}};
        }
        case 'SET_ASSETS_FILTER': {
            return {...state, assetsFilter: {...state.assetsFilter, ...action.payload}};
        }

        //BUDGET
        case 'SET_BUDGET_HEAD_COUNT_REPORT': {
            return {...state, headCountBudgetReport: {...state.headCountBudgetReport, ...action.payload}};
        }
         //Penalty Removal Report
        case 'SET_PENALTY_REMOVAL_REPORT': {
            return {...state, penaltyRemovalReport: {...state.penaltyRemovalReport, ...action.payload}};
        }
        default: {
            return state;
        }
    }
}
